import {atom} from 'recoil';

import {IContactPerson, IContactPersonToSubmit} from './../../shared/types/person.types';

export const contactPersonsOfCompanyQueryTrigger = atom<number>({
  key: 'contactPersonsOfCompanyQueryTrigger',
  default: 0,
});

export const contactPersonsToSubmitState = atom<IContactPersonToSubmit[]>({
  key: 'contactPersonsToSubmitState',
  default: [],
});

export const currentContactPersonIdState = atom<string>({
  key: 'currentContactPersonIdState',
  default: '',
});

export const contactPersonsOfCompanyState = atom<IContactPerson[]>({
  key: 'contactPersonsOfCompanyState',
  default: [],
});

export const currentContactPersonState = atom<IContactPerson | null>({
  key: 'currentContactPersonState',
  default: null,
});
